class JobPostsListingView extends ViewBasic {
    constructor(options) {
        super(options);
    }

    init(){
        super.init();
        this.addEvents();

        let waypoint = new Waypoint({
            element: this.$('.button-container'),
            offset: '100%',
            handler: function (direction) {
                if (direction == 'down') {
                    $(this.element).removeClass('fixed')
                }else{
                    $(this.element).addClass('fixed')
                }
            }
        });
    }

    addEvents() {

    }

    removeEvents() {

    }
}

